import React, { Component } from 'react';
import { ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import Select from 'react-select';
import { PeriodPicker } from './PeriodPicker';

export class SelectResourceAndPeriod extends Component {
  displayName = SelectResourceAndPeriod.name

  constructor(props) {
    super(props);

    this.state = {
      resourceGroups: [],
      resources: [],
      loadingResources: true,
      bookings: [],
      loadingBookings: true,
      selectedResource: null,
      selectedResourceGroup: null
    };

    fetch('api/ResourceGroups/' + this.props.tenant)
      .then(response => response.json())
      .then(data => {
        for (let i = 0; i < data.length; i++) {
          let translations = JSON.parse(data[i].description);
          if (translations !== null) {
            data[i].description = translations[this.props.lang];
          }
          else {
            data[i].description = data[i].rowKey;
          }
        }

        this.setState({ resourceGroups: data });

        if (data.length > 0) {
          this.onSelectedResourceGroupChange(data[0].rowKey);
          return data && data[0].rowKey;
        }
        else {
          return null;
        }
      }).then(firstResourceGroup => {
        fetch('api/Resources/' + this.props.tenant)
          .then(response => response.json())
          .then(data => {
            let selectedResource = null;
            
            if (this.props.resId) {
              data = data.filter(resource => resource.id === this.props.resId);
              selectedResource = data[0];

              this.onSelectedResourceGroupChange(data[0].rowKey);
            }
            else {
              selectedResource = this.props.selectedResource && { value: this.props.selectedResource.rowKey, label: this.props.selectedResource.description };
            }

            for (let i = 0; i < data.length; i++) {

              let translations = JSON.parse(data[i].description);
              if (translations !== null) {
                data[i].description = translations[this.props.lang];
              }
              else {
                data[i].description = data[i].rowKey;
              }

              if (selectedResource === null && data[i].resourceGroupId === firstResourceGroup) {
                selectedResource = data[i];
              }
            }

            this.setState({ resources: data, loadingResources: false });
            this.onSelectedResourceChange({ value: selectedResource.rowKey, label: selectedResource.description }, data);
          });
      });

    fetch('api/Reservations/' + this.props.tenant)
      .then(response => response.json())
      .then(data => {
        for (let i = 0; i < data.length; i++) {
          data[i].startDate = new Date(data[i].startDate);
          data[i].endDate = new Date(data[i].endDate);
        }
        this.setState({ bookings: data, loadingBookings: false });
      });
  }

  onPeriodChange(period) {
    if (this.props.onPeriodChange !== undefined) {
      this.props.onPeriodChange(period);
    }
  }

  getResourcesForGroup = resourceGroupId => this.state.resources.filter(resource => resource.resourceGroupId === resourceGroupId);

  onSelectedResourceChange(selectedValue) {
    this.setState({ selectedResource: selectedValue });

    if (this.props.onResourceChange !== undefined) {
      let resource = this.state.resources.filter(resource => resource.rowKey === selectedValue.value)[0];
      let resourceGroup = this.state.resourceGroups.filter(resourceGroup => resourceGroup.rowKey === this.state.selectedResourceGroup)[0];

      this.props.onResourceChange(resource, resourceGroup, false);
    }
  }

  onSelectedResourceGroupChange(selectedValue) {
    let firstAvailableResource = null;
    const availableResources = this.getResourcesForGroup(selectedValue);

    if (availableResources.length > 0) {
      firstAvailableResource = availableResources[0];
    }
    this.setState({ selectedResourceGroup: selectedValue, selectedResource: firstAvailableResource && { value: firstAvailableResource.rowKey, label: firstAvailableResource.description } });

    if (this.props.onResourceChange !== undefined) {
      let resourceGroup = this.state.resourceGroups.filter(resourceGroup => resourceGroup.rowKey === selectedValue)[0];
      this.props.onResourceChange(firstAvailableResource, resourceGroup, availableResources.length === 1);
    }
  }

  render() {
    const selectedResource = this.state.selectedResource;
    const selectedResourceGroup = this.state.selectedResourceGroup;
    const options = this.state.resources.filter(resource => resource.resourceGroupId === selectedResourceGroup).map(resource => { return { value: resource.rowKey, label: resource.description }; });
    const resourceCount = selectedResource === '' ? options.length : 1;
    const placeHolder = options.length === 0 ? '' : options[0].label;
    const className = options.length > 1 ? 'resource_select' : "hidden";
    const showSelectors = !this.props.resId;

    return (
      <div>
        { showSelectors && <div className="pl-5-ys">
          <ButtonToolbar>
            <ToggleButtonGroup className="hidden-ys" justified type="radio" name="resourceGroup" value={this.state.selectedResourceGroup} onChange={(selectedItem) => this.onSelectedResourceGroupChange(selectedItem)}>
              {this.state.resourceGroups.map(function (resourceGroup, index) {
                return (
                  <ToggleButton key={index} value={resourceGroup.rowKey}>{resourceGroup.description}</ToggleButton>
                );
              })}
            </ToggleButtonGroup>
            <ToggleButtonGroup className="visible-ys-block" vertical type="radio" name="resourceGroup" value={this.state.selectedResourceGroup} onChange={(selectedItem) => this.onSelectedResourceGroupChange(selectedItem)}>
              {this.state.resourceGroups.map(function (resourceGroup, index) {
                return (
                  <ToggleButton key={index} value={resourceGroup.rowKey}>{resourceGroup.description}</ToggleButton>
                );
              })}
            </ToggleButtonGroup>
          </ButtonToolbar>
        </div> }
        { showSelectors && <Select className={className} options={options} onChange={selectedItem => this.onSelectedResourceChange(selectedItem)} value={selectedResource} placeholder={placeHolder} /> }
        <PeriodPicker
          numberOfCalendars={2}
          resourceCount={resourceCount}
          resource={{ resourceGroup: selectedResourceGroup, resource: selectedResource }}
          bookings={this.state.bookings.filter(booking => selectedResource && booking.resourceId === selectedResource.value)}
          period={this.props.period}
          onChange={(period) => this.onPeriodChange(period)}
          localizations={this.props.localizations}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/SelectResourceAndPeriod.js